import './show-toast.scss';
import templateUrl from './show-toast.html';

/**
 * Inject showToast and showToast('Fou du fa fa');
 * Types: success, info, warn, error
 *
 * @example showToast('Fou du fa fa', 'error', 2000);
 * @ngInject
 */
export default /* @ngInject */ function($mdToast) {
    return function(message, type='success', hideDelay=5000) {
        $mdToast.show({
            controller: function() {
                this.message = message;
                this.type = type;
            },
            templateUrl: templateUrl,
            controllerAs: 'toast',
            hideDelay: hideDelay
        });
    };
}



// WEBPACK FOOTER //
// ./forms/services/show-toast.js